/** API rows may describe customers, suppliers or installers. Never stringify missing fields. */
export const savedText=(...values:unknown[]):string=>values.find((v):v is string=>typeof v==='string'&&v.trim().length>0&&v!=='undefined'&&v!=='null') as string|undefined ?? '';
/** "#1042" for a request number from the API (number or numeric string); '' when there is none. */
export const requestLabel=(value:unknown):string=>{const n=typeof value==='number'?value:typeof value==='string'&&/^\d+$/.test(value)?Number(value):NaN;return Number.isInteger(n)&&n>0?`#${n}`:'';};
export function communicationSummary(row:Record<string,unknown>){
 return {
  recipient:savedText(row.recipient_name,row.customer_name,row.recipient),
  subject:savedText(row.subject),
  address:savedText(row.recipient),
  channel:savedText(row.channel).toUpperCase(),
  href:`/communications?message=${encodeURIComponent(savedText(row.id))}`,
  /** The card's request number as Jacky reads it (#1042), or '' on drafts made before 4 Nov 2026. */
  number:requestLabel(row.request_no),
 };
}

/** A saved draft is attention while it is fresh: the same 72 h a proposal lives (policy
 * `case_expiry_hours`). One already reviewed through a case, or older than that, is history on
 * the Communications desk, not a demand. Jacky, 30 Sep 2026: five old or rejected drafts sat
 * under Immediate attention with no way out. */
export const DRAFT_ATTENTION_HOURS=72;
export function unreviewedDrafts(rows:Record<string,unknown>[], cases:{kase:{communication_id?:string|null}}[], now=Date.now()){
 const reviewed=new Set(cases.map(c=>c.kase.communication_id).filter(Boolean));
 const fresh=(row:Record<string,unknown>)=>{const at=Date.parse(String(row.created_at??''));return !Number.isFinite(at)||now-at<=DRAFT_ATTENTION_HOURS*3600_000;};
 // Newest first: the API pages by id, which is no order at all, and the drawer used to show the latest draft at the bottom.
 return rows.filter(row=>row.state==='draft'&&!reviewed.has(String(row.id))&&fresh(row)).sort((a,b)=>String(b.created_at??'').localeCompare(String(a.created_at??'')));
}

export function communicationOutcomeState(row:Record<string,unknown>|undefined,decision?:string):string{
 const state=savedText(row?.state);
 if(['queued','sending','submitted','failed','uncertain'].includes(state))return state;
 if(decision==='declined')return 'declined';
 if(decision==='revision requested')return 'revision';
 if(decision==='failed'||decision==='expired')return 'failed';
 return state||'unknown';
}
